import { render, staticRenderFns } from "./dialogHistory.vue?vue&type=template&id=523552fa&scoped=true"
import script from "./dialogHistory.vue?vue&type=script&lang=js"
export * from "./dialogHistory.vue?vue&type=script&lang=js"
import style0 from "./dialogHistory.vue?vue&type=style&index=0&id=523552fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523552fa",
  null
  
)

export default component.exports